const LOCALSTORAGE_CUSTOM_SECTIONS_NAME = 'global_sidebar_custom_sections'

window.addEventListener('message', messageHandler, false)

export enum IFrameInputMessageKeys {
  saveCustomUserSections = 'saveCustomUserSections',
  requestCustomUserSections = 'requestCustomUserSections'
}

export enum IFrameOutputMessageKeys {
  customUserSections = 'customSections'
}

function messageHandler (event: any) {
  if (event.data.key === IFrameInputMessageKeys.saveCustomUserSections) {
    window.localStorage.setItem(LOCALSTORAGE_CUSTOM_SECTIONS_NAME, JSON.stringify(event.data.data))
  } else if (event.data.key === IFrameInputMessageKeys.requestCustomUserSections) {
    event.source.postMessage({
      key: IFrameOutputMessageKeys.customUserSections,
      data: window.localStorage.getItem(LOCALSTORAGE_CUSTOM_SECTIONS_NAME)
    }, event.origin)
  }
}
